module.exports = __webpack_public_path__ + "static/icons/icon-snow-report--black-abe34fb4c29a4cc8502787d1f938573d.svg";